import { isValidPhoneNumber } from "react-phone-number-input";

export default (values, value) => {
  if (!value) return true;

  if (typeof value !== "string") return false;

  return isValidPhoneNumber(value);
};
